const accessStatus = {
  employee: 'ENTRY ALLOWED',
  employee1: 'BLOCKED ENTRY',
  company: 'RELEASED',
  company1: 'NOT RELEASED'
};

export default accessStatus;
